import { katTranslator } from '../../shared/i18n';

export const strings = {
  // AST String ID: kat_date_range_picker_start_date
  date_range_picker_start_date: {
    'en-US': 'Start Date',
    'ar-AE': 'تاريخ البدء',
    'pt-BR': 'Data de início',
    'zh-TW': '開始日期',
    'kn-IN': 'ಆರಂಭ ದಿನಾಂಕ',
    'tr-TR': 'Başlangıç tarihi.',
    'ko-KR': '시작 날짜',
    'mr-IN': 'सुरू होण्याची तारीख',
    'ml-IN': 'തുടങ്ങുന്ന തീയതി',
    'fr-BE': 'Date de début',
    'fr-FR': 'Date de début',
    'cs-CZ': 'Datum zahájení',
    'it-IT': 'Data di inizio',
    'he-IL': 'תאריך התחלה',
    'fr-CA': 'Date de début',
    'pt-PT': 'Data de início',
    'ja-JP': '開始日',
    'bn-IN': 'আরম্ভের তারিখ',
    'te-IN': 'ప్రారంభ తేదీ',
    'es-ES': 'Fecha de inicio',
    'de-DE': 'Startdatum',
    'da-DK': 'Startdato',
    'ta-IN': 'தொடக்கத் தேதி',
    'es-CL': 'Fecha inicial',
    'nl-NL': 'Startdatum',
    'nl-BE': 'Startdatum',
    'sv-SE': 'Startdatum',
    'es-US': 'Fecha de inicio',
    'es-CO': 'Fecha de inicio',
    'hi-IN': 'शुरू होने की तारीख',
    'zh-CN': '开始日期',
    'es-MX': 'Fecha de inicio',
    'pl-PL': 'Data rozpoczęcia',
  },
  // AST String ID: kat_date_range_picker_end_date
  date_range_picker_end_date: {
    'en-US': 'End Date',
    'ar-AE': 'تاريخ الانتهاء',
    'pt-BR': 'Data de término',
    'zh-TW': '結束日期',
    'kn-IN': 'ಮುಕ್ತಾಯ ದಿನಾಂಕ',
    'tr-TR': 'Bitiş tarihi.',
    'ko-KR': '종료 날짜',
    'mr-IN': 'अंतिम तारीख',
    'ml-IN': 'അവസാനിക്കുന്ന തീയതി',
    'fr-BE': 'Date de fin',
    'fr-FR': 'Date de fin',
    'cs-CZ': 'Datum ukončení',
    'it-IT': 'Data di fine',
    'he-IL': 'תאריך סיום',
    'fr-CA': 'Date de fin',
    'pt-PT': 'Data de fim',
    'ja-JP': '終了日',
    'bn-IN': 'সমাপ্তির তারিখ',
    'te-IN': 'ముగింపు తేదీ',
    'es-ES': 'Fecha de finalización',
    'de-DE': 'Enddatum',
    'da-DK': 'Slutdato',
    'ta-IN': 'முடிவுத் தேதி',
    'es-CL': 'Fecha final',
    'nl-NL': 'Einddatum',
    'nl-BE': 'Einddatum',
    'sv-SE': 'Slutdatum',
    'es-US': 'Fecha de finalización',
    'es-CO': 'Fecha de finalización',
    'hi-IN': 'समाप्ति की तारीख',
    'zh-CN': '结束日期',
    'es-MX': 'Fecha de finalización',
    'pl-PL': 'Data zakończenia',
  },
};

export default katTranslator(strings);
